import { useState } from "react";
import { Link } from "react-router";
import type { Me } from "../../shared/types.ts";
import { api } from "../lib/api.ts";
import { useT } from "../lib/i18n.tsx";
import { useMe } from "../lib/me.tsx";

/** T4.4: versioned re-acceptance prompt shown until the user accepts the current policy version. */
export function TermsPrompt() {
  const t = useT();
  const { me, setMe } = useMe();
  const [busy, setBusy] = useState(false);
  if (!me || !me.terms_outdated || me.needs_onboarding) return null;
  async function accept() {
    setBusy(true);
    try {
      await api("/api/policy/accept", { body: { terms_version: me!.terms_current } });
      setMe({ ...me!, terms_outdated: false, terms_version: me!.terms_current } as Me);
    } finally {
      setBusy(false);
    }
  }
  return (
    <div className="banner banner--warn" role="status" data-testid="terms-prompt">
      <span>{t("legal.reaccept")}</span> <Link to="/legal/terms">{t("legal.terms")}</Link> ·{" "}
      <Link to="/legal/privacy">{t("legal.privacy")}</Link>{" "}
      <button
        className="btn btn--accent"
        disabled={busy}
        onClick={() => void accept()}
        data-testid="terms-accept"
      >
        {t("common.confirm")}
      </button>
    </div>
  );
}
